import { useLang } from "../contexts/LanguageContext";
import { PRODUCTS } from "../data/products";
import { ArrowUpRight } from "lucide-react";

export function ProductsSection({ onSelect }) {
  const { lang, t } = useLang();

  return (
    <section
      id="products"
      data-testid="products-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-background"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16">
        <div className="md:col-span-5">
          <p className="tracking-eyebrow uppercase text-xs text-secondary mb-4">
            {t.products.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            {t.products.title}
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7 self-end">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            {t.products.lead}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {PRODUCTS.map((p) => {
          return (
            <article
              key={p.code}
              data-testid={`product-card-${p.code}`}
              className="group bg-card border border-border overflow-hidden flex flex-col"
            >
              <div className="grid grid-cols-1 sm:grid-cols-5 h-full">
                <div className="sm:col-span-2 aspect-[4/3] sm:aspect-auto overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.titles[lang]}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="sm:col-span-3 p-6 md:p-8 flex flex-col justify-between gap-6">
                  <div className="space-y-3">
                    <p className="tracking-eyebrow text-[10px] uppercase text-secondary">
                      {p.icao} · {p.origin[lang]}
                    </p>
                    <h3 className="font-display text-2xl md:text-3xl leading-tight">
                      {p.titles[lang]}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {p.descriptions[lang]}
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {p.specs.map((s) => (
                      <span
                        key={s}
                        className="text-[11px] tracking-wide uppercase px-2.5 py-1 bg-accent text-accent-foreground"
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                  <button
                    data-testid={`product-select-${p.code}`}
                    onClick={() => onSelect?.(p.code)}
                    className="self-start inline-flex items-center gap-2 text-sm text-primary border-b border-primary pb-1 hover:border-secondary hover:text-secondary transition-colors"
                  >
                    {t.products.learn_more}
                    <ArrowUpRight strokeWidth={1.6} size={16} />
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
